import React from 'react'
import { Link } from 'react-router-dom'
import Navegacion from './Navegacion'
import Hamburger from './Hamburger'
import Logo from '../componentes/Logo'

const Header = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    return (
        <header className="header f f-ac f-jcsb">
            <Link to={'/'} rel="preload">
                <Logo />
            </Link>
            <Navegacion />
            <Hamburger />
        </header>
    )
}

export default Header